// extracted by mini-css-extract-plugin
module.exports = {"icon":"ContactAndSupport_icon__3a86G","border":"ContactAndSupport_border__31IAB"};